const logs = [
    {
        label: 'Sign Missing',
        facility_unit: 'B210/1A',
        date: '3-30-2020',
        color: 'border-danger',
        key: 0
    },
    {
        label: 'Sign Missing',
        facility_unit: 'B210/1A',
        date: '3-29-2020',
        color: 'border-danger',
        key: 1
    },
    {
        label: 'Signed',
        facility_unit: 'B210/1A',
        date: '3-28-2020',
        color: 'border-success',
        key: 2
    },
    {
        label: 'Signed (Review)',
        facility_unit: 'B210/1A',
        date: '3-27-2020',
        color: 'border-warning',
        key: 3
    },
    {
        label: 'Signed (Review)',
        facility_unit: 'B210/1A',
        date: '3-26-2020',
        color: 'border-warning',
        key: 4
    },
    {
        label: 'Signed',
        facility_unit: 'B210/1A',
        date: '3-25-2020',
        color: 'border-success',
        key: 5
    },
    {
        label: 'Sign Missing',
        facility_unit: 'B210/1A',
        date: '3-24-2020',
        color: 'border-danger',
        key: 6
    },
    {
        label: 'Signed',
        facility_unit: 'B210/1A',
        date: '3-23-2020',
        color: 'border-success',
        key: 7
    },
    {
        label: 'Signed',
        facility_unit: 'B210/1A',
        date: '3-22-2020',
        color: 'border-success',
        key: 8
    },
    {
        label: 'Signed',
        facility_unit: 'B210/1A',
        date: '3-21-2020',
        color: 'border-success',
        key: 9
    },
    {
        label: 'Signed',
        facility_unit: 'B210/1A',
        date: '3-20-2020',
        color: 'border-success',
        key: 10
    }
]
export default logs
